
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import LivePageHeader from '@/components/LivePageHeader'
import LandingPageHeader from '@/components/LandingPageHeader'
import LandingPageHeaderXhs from '@/components/LandingPageHeaderXhs'
import LandingPageFooter from '@/components/LandingPageFooter'
import LivePageFooter from '@/components/LivePageFooter'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import { authRegister } from '@/api/user'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
LivePageHeader,
LandingPageHeader,
LandingPageHeaderXhs,
LandingPageFooter,
LivePageFooter,
IndexSidebar,
IndexFooter,
XInput,
Group,
Toast,
Swiper,
SwiperItem
},
data () {
return {
tabIndex: 0,
tabIndex1: 0,
tabIndex2: 0,
resourceTabIndex: 0,
resourceTravel: [],
resourceMoney: [],
resourceFood: [],
resourceBeauty: [],
loginModel: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
loginModel2: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
getTextCode: '获取验证码',
captchaImg: '/static/images/vcode.jpg',
smsCount: 0,
smsDisable: false,
scrollTop: 0,
xhsImgList: [
'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_age.png',
'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_area.png',
'https://static.xinmeibao.com/assets_mobile/v2/new_guest_xhs_sex.png'
],
xhsImgList1: [
{
img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_200.png'
},
{
img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_100.png'
},
{
img: 'https://static.xinmeibao.com/assets_mobile/v2/news_guest_xhs1_50.png'
}
],
xhsImgList1_index: 0,
xhs1_swiper_index: 0,
currentIndex: 0
}
},
methods: {



handleDoubleData () {
let fly = new Fly() 

fly.request('https://www.xinmeibao.com//api/web_weibo', {}, {method: 'get'})
.then(resp => {
var transferData = JSON.parse(resp.data)
if (transferData.success) {
this.resourceTravel = transferData.message.travel
this.resourceFood = transferData.message.food
this.resourceMoney = transferData.message.money
this.resourceBeauty = transferData.message.beauty
}
})
.catch(e => console.log('error', e))
},


getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true 
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {method: 'post'})
.then(resp => {
this.captchaImg = resp.data.data.src
this.loginModel.captcha_token = resp.data.data.captcha_token
this.loginModel2.captcha_token = resp.data.data.captcha_token
})
.catch(e => console.log('error', e))
},

getTextCaptcha (type) {
if (!this.smsDisable) {
if (type === 2) {
if (!this.loginModel2.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel2.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
} else {
if (!this.loginModel.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
}

const textCaptchaModel =
type === 2 ? {
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
mobile: this.loginModel2.mobile,
scope: 'mobile_signup'
} : {
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
mobile: this.loginModel.mobile,
scope: 'mobile_signup'
}
let fly = new Fly() 
fly
.request('https://api.ruan.net/api/auth/captcha/sms',
textCaptchaModel, {method: 'post'}
)
.then(resp => {
if (!resp.data.success) {
this.getCaptcha()
} else {
this.smsCountDown()
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})

})
.catch(e => console.log('获取短信验证码失败', e))
}
},

smsCountDown () {
const _this = this
_this.smsCount = 60
_this.smsDisable = true
let interval = window.setInterval(function () {
--_this.smsCount
if (_this.smsCount === 0) {
_this.smsDisable = false
window.clearInterval(interval)
}
}, 1000)
},


login (type) {

const password = Math.random()
.toString()
.substr(2)
.slice(0, 6)

const registerModel =
type === 2 ? {
mobile: this.loginModel2.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
captcha_sms: this.loginModel2.msgcode,
scope: 'mobile_signup',
device: 'wap'
}
: {
mobile: this.loginModel.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
captcha_sms: this.loginModel.msgcode,
scope: 'mobile_signup',
device: 'wap'
}
authRegister(registerModel)
.then(res => {
this.$vux.toast.show({
text: res.message,
time: 1000
})
this.$router.push('/media?tab=xhs')
})
.catch(e => {
console.log('注册失败', e)
this.$vux.toast.show({
text: e.message,
type: 'cancel',
time: 2000
})
this.getCaptcha()
this.loginModel.captcha = ''
this.loginModel2.captcha = ''
})
},
goAnchor (selector) {
console.log(this.$parent.$parent.$refs.viewBox.scrollTo)
var anchor = this.$el.querySelector(selector)

this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100)
},

changeTab (index) {
this.tabIndex = index

},
change_resourceTabIndex (index) {
this.tabIndex1 = index
},
change_caseTab (index) {
this.tabIndex2 = index
}
},
mounted () {
this.getCaptcha()
}
}



// WEBPACK FOOTER //
// ./src/pages/live/index.vue